export const cartData = [
  { id: 1, name: "Samsung Galaxy 9", quantity: 4, amount: 6000 },
  { id: 2, name: "Infinix Note 8..", quantity: 4, amount: 57575 },
  { id: 3, name: "Samsung Galaxy S21..", quantity: 4, amount: 9000 },
  { id: 4, name: "Samsung Galaxy S21..", quantity: 4, amount: 57575 },
  { id: 5, name: "Samsung Galaxy 9", quantity: 4, amount: 6000 },
  { id: 6, name: "Infinix Note 8..", quantity: 4, amount: 57575 },
  { id: 7, name: "Samsung Galaxy S21..", quantity: 4, amount: 9000 },
];
